'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _chart = require('helpers/chart');

var _ChartWrapper = require('components/ChartWrapper/ChartWrapper');

var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('components/Chart/Chart.scss');

var PopularityChart = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(PopularityChart, _PureComponent);

  function PopularityChart() {
    (0, _classCallCheck3.default)(this, PopularityChart);
    return (0, _possibleConstructorReturn3.default)(this, (PopularityChart.__proto__ || (0, _getPrototypeOf2.default)(PopularityChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(PopularityChart, [{
    key: 'getTooltip',
    value: function getTooltip(_ref) {
      var isHTML = _ref.isHTML,
          data = _ref.data;
      var t = this.context.t;

      if (isHTML) {
        return '\n        <div class="' + styles.tooltip + '">\n          <div><b>' + data.trackName + '</b></div>\n          <div class="nowrap">' + t('Avg playtime') + ': <b>' + data.avgPlaytimeString + '</b></div>\n          <div class="nowrap">' + t('Times played') + ': <b>' + data.plays + '</b></div>\n          <div class="nowrap">' + t('Times downloaded') + ': <b>' + data.downloads + '</b></div>\n        </div>\n      ';
      }

      return t('Times played') + ': ' + data.plays;
    }
  }, {
    key: 'getChartData',
    value: function getChartData() {
      var _this2 = this;

      var data = this.props.data;
      var t = this.context.t;

      return [[t('Track name'), t('Avg Playtime (min)'), { type: 'string', role: 'tooltip', p: { html: true } }, // eslint-disable-line id-length
      { type: 'string', role: 'style' }]].concat((0, _toConsumableArray3.default)((0, _chart.getDataArray)({
        data: data,
        keyName: 'trackName',
        valueName: function valueName(current) {
          return [current.avgPlaytimeDate, _this2.getTooltip({ data: current, isHTML: true }), 'stroke-width: 100;'];
        },
        sortBy: 'desc'
      })));
    }
  }, {
    key: 'getChartProps',
    value: function getChartProps() {
      var id = this.props.id;

      var data = this.getChartData();

      return {
        graphId: id,
        chartType: 'BarChart',
        data: data,
        options: {
          hAxis: {
            minValue: new Date(0),
            viewWindow: {
              min: new Date(0)
            },
            format: 'mm:ss'
          },
          tooltip: { isHtml: true }
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var loading = this.props.loading;

      var chartProps = this.getChartProps();

      return _react2.default.createElement(_ChartWrapper2.default, {
        legendHeight: 50,
        showMore: true,
        limit: 10,
        chartProps: chartProps,
        loading: loading
      });
    }
  }]);
  return PopularityChart;
}(_react.PureComponent), _class2.propTypes = {
  data: _propTypes2.default.array,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  data: [],
  id: 'popularityChart'
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
exports.default = PopularityChart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/PopularityChart/PopularityChart.js
// module id = 847
// module chunks = 1